import { render, staticRenderFns } from "./Sites.vue?vue&type=template&id=7d0b537f&"
import script from "./Sites.vue?vue&type=script&lang=js&"
export * from "./Sites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jogg/jogg-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d0b537f')) {
      api.createRecord('7d0b537f', component.options)
    } else {
      api.reload('7d0b537f', component.options)
    }
    module.hot.accept("./Sites.vue?vue&type=template&id=7d0b537f&", function () {
      api.rerender('7d0b537f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/Sites.vue"
export default component.exports